module.exports = __webpack_public_path__ + "img/20.644de36f.png";